import { NodeType } from '@amarantos/api-client'

export type NodeAdditionalInfoField = 'weight' | 'purpose'

export const nodeAdditionalInfoField: Record<NodeType, NodeAdditionalInfoField | null> = {
	[NodeType.manhole]: null,
	[NodeType.soakaway]: null,
	[NodeType.pump_station]: 'weight',
	[NodeType.tank]: 'purpose',
	[NodeType.separator]: null,
	[NodeType.tie_in]: null,
	[NodeType.inlet]: null,
}
